import { getQueryString, handleError, page_size } from "../apiUtils";
import { createAxiosInstance } from "../apiUtils";

export async function getDestinationsList(token: string, query: object) {
    const axiosInstance = await createAxiosInstance(token);
    const query_string = getQueryString(query)
    try {
        const resp = await axiosInstance.get("/v2/integrations/?action_type=push&is_used_as_provider=false&pager=limit&limit=" + page_size + "&" + query_string);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}

// Returns how many destinations the user can see across all their workspaces
// (the API already scopes results to the user's visibility). Callers compare
// this against a connection's attached destinations to decide whether there
// is anything left to pick.
export async function countAvailableDestinations(token: string) {
    const resp = await getDestinationsList(token, {});
    // handleError swallows some failures (e.g. 401) and resolves undefined;
    // treat that as unknown rather than "no destinations" so callers fall
    // back to their safe path instead of misrouting to the create flow
    if (!resp) throw new Error("Failed to check destination availability");
    return resp.count;
}

export async function getDestinationTypes(token: string, query?: object) {
    const axiosInstance = await createAxiosInstance(token);
    const query_string = getQueryString({ limit: page_size, ...(query || {}) })
    try {
        const resp = await axiosInstance.get("/v2/integrations/types/?action_type=push&pager=limit&" + query_string);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}

export async function getDestinationUrls(token: string, query?: object) {
    const axiosInstance = await createAxiosInstance(token);
    const query_string = getQueryString({ limit: page_size, ...(query || {}) })
    try {
        const resp = await axiosInstance.get("/v2/integrations/urls/?action_type=push&pager=limit&" + query_string);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}

export async function addDestination(token: string, new_destination: object) {
    const axiosInstance = await createAxiosInstance(token);
    try {
        const resp = await axiosInstance.post("/v2/integrations/", new_destination);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}

export async function getDestinationDetails(token: string, destination_id: string) {
    const axiosInstance = await createAxiosInstance(token);
    try {
        const resp = await axiosInstance.get("/v2/integrations/" + destination_id);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}

export async function updateDestination(token: string, destination_id: string, destination: object) {
    const axiosInstance = await createAxiosInstance(token);
    try {
        const resp = await axiosInstance.patch("/v2/integrations/" + destination_id + "/", destination);
        return resp.data;
    } catch (err) {
        handleError(err);
    }
}
